let slickDefaults = require('../slick-default/slick-default');

let size = require('../../modules/size');

jQuery(function() {
    let $container = $('.js-slick-brands');
    let settings = $.extend({}, slickDefaults.params, slickDefaults.paramsCssAnim, {
        slidesToShow: 5,
        responsive: [
            {
                breakpoint: size.desktop,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: size.tabletBig,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: size.tablet,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: size.mobileBig,
                settings: 'unslick'
            }
        ]
    });
    runSlick($container, settings);
    $(window).resize(function() {
        let width = window.innerWidth || document.body.clientWidth;
        if (!$container.hasClass('slick-initialized') && width > size.mobileBig) {
            runSlick($container, settings);
        }
    });
});

function runSlick($sliderContainer, settings) {
    $sliderContainer.each(function() {
        $(this).slick(settings);
    });
}



// WEBPACK FOOTER //
// ./blocks/brands-slider/slider-resize-controll.js